import { useQuery } from '@tanstack/react-query'
import { getTables } from '../services/TableService'
import type { Table } from '../types/@types/table'

export function useTables() {
  return useQuery<Table[]>({
    queryKey: ['tables'],
    queryFn: getTables,
  })
}

